interface OneTimeCodeFieldProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  id?: string;
}

/** The six-digit emailed-code input shared by the /join verify step. */
export function OneTimeCodeField({
  value,
  onChange,
  label = "Enter the code we emailed you",
  id = "join-code",
}: OneTimeCodeFieldProps) {
  return (
    <div className="w-full">
      <label htmlFor={id} className="mb-1.5 block text-sm font-medium text-fg-muted">
        {label}
      </label>
      <input
        id={id}
        autoComplete="one-time-code"
        autoFocus
        inputMode="numeric"
        maxLength={6}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-xl border border-border bg-bg px-3 py-3 text-center text-3xl font-semibold tracking-[0.5em] indent-[0.5em] tabular-nums text-fg outline-none transition focus:border-pro focus:ring-2 focus:ring-pro/15"
      />
    </div>
  );
}
